// Function to Generate a Random 6-Digit ID
const generateId = () => Math.floor(100000 + Math.random() * 900000).toString();

export const productData = [
  {
    id: generateId(),
    productName: "Whey Protein",
    category: "Supplements",
    price: 45.99,
    stock: 20,
    status: "Active",
    description: "Premium whey protein for muscle recovery and growth.",
    images: [
      "https://picsum.photos/200/300?random=1",
      "https://picsum.photos/200/300?random=2",
      "https://picsum.photos/200/300?random=3",
    ],
  },
  {
    id: generateId(),
    productName: "Adjustable Dumbbells",
    category: "Gym Equipment",
    price: 89.99,
    stock: 5,
    status: "Active",
    description: "Perfect for home workouts with adjustable weight settings.",
    images: [
      "https://picsum.photos/200/300?random=4",
      "https://picsum.photos/200/300?random=5",
    ],
  },
  {
    id: generateId(),
    productName: "Yoga Mat",
    category: "Gym Equipment",
    price: 29.99,
    stock: 15,
    status: "Active",
    description: "Non-slip yoga mat with extra cushioning for comfort.",
    images: [
      "https://picsum.photos/200/300?random=6",
      "https://picsum.photos/200/300?random=7",
    ],
  },
  {
    id: generateId(),
    productName: "BCAA Powder",
    category: "Supplements",
    price: 39.99,
    stock: 8,
    status: "Active",
    description: "Essential amino acids for muscle recovery and hydration.",
    images: [
      "https://picsum.photos/200/300?random=8",
      "https://picsum.photos/200/300?random=9",
    ],
  },
  {
    id: generateId(),
    productName: "Compression Shirt",
    category: "Clothing",
    price: 24.99,
    stock: 12,
    status: "Inactive",
    description: "Breathable compression shirt for workouts and recovery.",
    images: [
      "https://picsum.photos/200/300?random=10",
      "https://picsum.photos/200/300?random=11",
    ],
  },
  {
    id: generateId(),
    productName: "Treadmill Lubricant",
    category: "Gym Equipment",
    price: 14.99,
    stock: 30,
    status: "Active",
    description: "Keeps your treadmill running smoothly and quietly.",
    images: [
      "https://picsum.photos/200/300?random=12",
    ],
  },
  {
    id: generateId(),
    productName: "Resistance Bands Set",
    category: "Gym Equipment",
    price: 19.99,
    stock: 25,
    status: "Active",
    description: "Set of 5 resistance bands for strength training and stretching.",
    images: [
      "https://picsum.photos/200/300?random=13",
      "https://picsum.photos/200/300?random=14",
    ],
  },
  {
    id: generateId(),
    productName: "Pre-Workout Supplement",
    category: "Supplements",
    price: 34.99,
    stock: 10,
    status: "Active",
    description: "Boosts energy and focus for intense workouts.",
    images: [
      "https://picsum.photos/200/300?random=15",
      "https://picsum.photos/200/300?random=16",
    ],
  },
  {
    id: generateId(),
    productName: "Foam Roller",
    category: "Gym Equipment",
    price: 22.99,
    stock: 18,
    status: "Active",
    description: "Helps with muscle recovery and reducing soreness.",
    images: [
      "https://picsum.photos/200/300?random=17",
      "https://picsum.photos/200/300?random=18",
    ],
  },
  {
    id: generateId(),
    productName: "Gym Gloves",
    category: "Accessories",
    price: 15.99,
    stock: 20,
    status: "Active",
    description: "Protects hands during weightlifting and other exercises.",
    images: [
      "https://picsum.photos/200/300?random=19",
      "https://picsum.photos/200/300?random=20",
    ],
  },
  {
    id: generateId(),
    productName: "Protein Shaker Bottle",
    category: "Accessories",
    price: 9.99,
    stock: 50,
    status: "Active",
    description: "Convenient bottle for mixing protein shakes on the go.",
    images: [
      "https://picsum.photos/200/300?random=21",
      "https://picsum.photos/200/300?random=22",
    ],
  },
  {
    id: generateId(),
    productName: "Kettlebell Set",
    category: "Gym Equipment",
    price: 99.99,
    stock: 7,
    status: "Active",
    description: "Set of 3 kettlebells for full-body workouts.",
    images: [
      "https://picsum.photos/200/300?random=23",
      "https://picsum.photos/200/300?random=24",
    ],
  },
  {
    id: generateId(),
    productName: "Fitness Tracker",
    category: "Accessories",
    price: 59.99,
    stock: 12,
    status: "Active",
    description: "Tracks steps, heart rate, and calories burned.",
    images: [
      "https://picsum.photos/200/300?random=25",
      "https://picsum.photos/200/300?random=26",
    ],
  },
  {
    id: generateId(),
    productName: "Jump Rope",
    category: "Gym Equipment",
    price: 12.99,
    stock: 40,
    status: "Active",
    description: "Durable jump rope for cardio workouts.",
    images: [
      "https://picsum.photos/200/300?random=27",
      "https://picsum.photos/200/300?random=28",
    ],
  },
  {
    id: generateId(),
    productName: "Weightlifting Belt",
    category: "Accessories",
    price: 29.99,
    stock: 10,
    status: "Active",
    description: "Provides support and stability during heavy lifts.",
    images: [
      "https://picsum.photos/200/300?random=29",
      "https://picsum.photos/200/300?random=30",
    ],
  },
  {
    id: generateId(),
    productName: "Creatine Monohydrate",
    category: "Supplements",
    price: 24.99,
    stock: 15,
    status: "Active",
    description: "Supports muscle strength and power output.",
    images: [
      "https://picsum.photos/200/300?random=31",
      "https://picsum.photos/200/300?random=32",
    ],
  },
  {
    id: generateId(),
    productName: "Pull-Up Bar",
    category: "Gym Equipment",
    price: 49.99,
    stock: 6,
    status: "Active",
    description: "Doorway-mounted pull-up bar for upper body workouts.",
    images: [
      "https://picsum.photos/200/300?random=33",
      "https://picsum.photos/200/300?random=34",
    ],
  },
  {
    id: generateId(),
    productName: "Gym Towel",
    category: "Accessories",
    price: 8.99,
    stock: 60,
    status: "Active",
    description: "Absorbent towel for gym and fitness activities.",
    images: [
      "https://picsum.photos/200/300?random=35",
      "https://picsum.photos/200/300?random=36",
    ],
  },
  {
    id: generateId(),
    productName: "Weight Bench",
    category: "Gym Equipment",
    price: 129.99,
    stock: 4,
    status: "Active",
    description: "Adjustable weight bench for versatile workouts.",
    images: [
      "https://picsum.photos/200/300?random=37",
      "https://picsum.photos/200/300?random=38",
    ],
  },
  {
    id: generateId(),
    productName: "Multivitamin Tablets",
    category: "Supplements",
    price: 19.99,
    stock: 30,
    status: "Active",
    description: "Daily multivitamin for overall health and wellness.",
    images: [
      "https://picsum.photos/200/300?random=39",
      "https://picsum.photos/200/300?random=40",
    ],
  },
];